export default __webpack_public_path__ + "static/media/sort-down.400ad85e.svg";